// Packages
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
// Helpers, Utils etc.
import { formatDecimal } from "../../helpers/itemCalculations";
import { loyaltyExpiryNotice } from "../../helpers/loyaltyExpiry";

interface ILoyaltyExpiryNoteProps {
  loyalty: any;
  currency: string;
  className?: string;
}

// "AED 25.00 expires in 20 days (2 Nov)" under a loyalty balance.
// Renders nothing unless loyalty expires within the next 30 days.
const LoyaltyExpiryNote = (props: ILoyaltyExpiryNoteProps) => {
  const intl = useIntl();
  const notice = loyaltyExpiryNotice(props.loyalty);
  if (!notice) return null;

  const { amount, date, days } = notice;
  const values = {
    amount: `${props.currency} ${formatDecimal(amount)}`,
    days: days,
    date: intl.formatMessage(
      { id: "loyalty.expiry.date", defaultMessage: "{day} {month}" },
      {
        day: intl.formatDate(date, { day: "numeric" }),
        month: intl.formatDate(date, { month: "short" }),
      }
    ),
  };

  return (
    <p className={`loyalty-expiry-note ${props.className || ""}`.trim()}>
      {days <= 0 ? (
        <FormattedMessage
          id="loyalty.expiry.expires_today"
          defaultMessage="{amount} expires today ({date})"
          values={values}
        />
      ) : days === 1 ? (
        <FormattedMessage
          id="loyalty.expiry.expires_tomorrow"
          defaultMessage="{amount} expires tomorrow ({date})"
          values={values}
        />
      ) : (
        <FormattedMessage
          id="loyalty.expiry.expires_in_days"
          defaultMessage="{amount} expires in {days, plural, one {# day} other {# days}} ({date})"
          values={values}
        />
      )}
    </p>
  );
};

export default LoyaltyExpiryNote;
